const createSVGFromText = (content, settings = {}) => {
    /**
     * The user can overwrite all the settings by sending the desired items
     */
    const defaultSettings = {
        svg: {
            'viewbox': '0 0 30 30',
            'width': '30',
            'height': '30',
            'style': 'background-color: rgb(239, 242, 247);'
        },
        text: {
            'x': 15,
            'y': 15,
            'dominant-baseline': 'middle',
            'text-anchor': 'middle',
            'style': 'font-familly: Inter, sans-serif;fill: rgb(80, 93, 105);font-weight:bold;font-size: 14px;'
        }
    };

    const SVG_NS = "http://www.w3.org/2000/svg";

    let svg = document.createElementNS(SVG_NS, 'svg');
    let text = document.createElementNS(SVG_NS, "text");

    const gotTextSettings = settings?.text || {};

    for (const attrKey in defaultSettings.text) {
        text.setAttributeNS(null, attrKey, (gotTextSettings[attrKey] || defaultSettings.text[attrKey]));
    }

    const gotSVGSettings = settings?.svg || {};

    for (const attrKey in defaultSettings.svg) {
        svg.setAttributeNS(null, attrKey, (gotSVGSettings[attrKey] || defaultSettings.svg[attrKey]));
    }

    text.textContent = content;

    svg.appendChild(text);

    return svg;
}

const generateLogDescription = (t, action, section, hardwareType) => {
    let desc = "";
    switch (action) {
        case "create":
            desc = `${t("A new")} ${t(hardwareType?.toLowerCase())} ${t(
                "was added to the records."
            )}`;
            break;
        case "delete":
            desc = `Remove ${section?.toLowerCase()} devices from the system's records.`;
            break;
        case "handover":
            desc = `Document the transfer of ownership or responsibility for data or equipment.`;
            break;
        case "add_owner":
            desc = `Register new owners for specific devices or software.`;
            break;
        case "delete_owner":
            desc = `Remove ownership records from the system.`;
            break;
        case "edit":
            desc = `Modify and refresh existing ${section?.toLowerCase()} information.`;
            break;
        case "add_module":
            desc = `Module is added`;
            break;
        case "remove_module":
            desc = `Module is removed`;
            break;
        case "change_responsible_person":
            desc = `Responsible person has been changed`;
            break;
        case "change_company":
            desc = "Company has been changed";
            break;
        case "change_position":
            desc = "Position has been changed";
            break;
        case "change_email":
            desc = "Email has been changed";
            break;
        case "change_phone_number":
            desc = "Phone number has been changed";
            break;
        case "change_responsible_department":
            desc = "Responsible department has been changed";
            break;
        case "dpia":
            desc = `Revise and update Data Protection Impact Assessment (DPIA) records for ${section?.toLowerCase()}.`;
            break;
        case "create_processing_activity":
            desc = 'A new activity was added.';
            break;
        case "change_processing_activity":
            desc = `Answers in processing activity changed `;
            break;
        case "upload_csv":
            desc = t("Upload processing activity data from Excel file");
            break;
        case "download":
            desc = t("Download");
            break;
        case "toggle_flag":
            desc = t("Change flag");
            break;
        case "change_status":
            desc = t("Change Status");
            break;
        case "change_priority":
            desc = t("Change Priority");
            break;
        case "change_analyst":
            desc = t("Change Analyst Assigned");
            break;
        case "remove_processing_activity":
            desc = `An activity was deleted.`;
            break;
        case "update_processing_activity_module_name":
            desc = `Update the activity title.`;
            break;
        case "update_responsible_person":
            desc = 'The responsible person was changed.';
            break;
        case "add_processing_activity_module_name":
            desc = `A new module name was added to the processing activity.`;
            break;
        default:
            desc = "";
            break;
    }

    return t(desc);
};

const generateLogAction = (t, action) => {
    let desc = "";
    switch (action) {
        case "create":
            desc = t("Created");
            break;
        case "delete":
            desc = t("Deleted");
            break;
        case "handover":
            desc = t("Handover");
            break;
        case "add_owner":
            desc = t("Added a new owner");
            break;
        case "delete_owner":
            desc = t("Deleted an owner");
            break;
        case "edit":
            desc = t("Edit detail");
            break;
        case "add_module":
            desc = t("Module is added");
            break;
        case "remove_module":
            desc = t("Module is removed");
            break;
        case "change_responsible_person":
            desc = t("Responsible changed");
            break;
        case "change_company":
            desc = t("Company changed");
            break;
        case "change_position":
            desc = t("Position changed");
            break;
        case "change_email":
            desc = t("Email changed");
            break;
        case "change_phone_number":
            desc = t("Phone number changed");
            break;
        case "change_responsible_department":
            desc = t("Responsible department changed");
            break;
        case "dpia":
            desc = t("DPIA");
            break;
        case "create_processing_activity":
            desc = t("Create processing activity");
            break;
        case "change_processing_activity":
            desc = t("Update processing activity details");
            break;
        case "upload_csv":
            desc = t("Upload processing activity data from Excel file");
            break;
        case "download":
            desc = t("Download");
            break;
        case "toggle_flag":
            desc = t("Change flag");
            break;
        case "change_status":
            desc = t("Change Status");
            break;
        case "change_priority":
            desc = t("Change Priority");
            break;
        case "change_analyst":
            desc = t("Change Analyst Assigned");
            break;
        case "remove_processing_activity":
            desc = t("Removed processing activity");
            break;
        case "update_processing_activity_module_name":
            desc = t("Updated processing activity module name");
            break;
        case "add_processing_activity_module_name":
            desc = t("Added processing activity module name");
            break;
        default:
            desc = "";
            break;
    }

    return desc;
};

export {
    createSVGFromText,
    generateLogDescription,
    generateLogAction
};